<template>
  <div>
    系统自动登录中,请稍后...
  </div>
</template>

<script>
export default {
  name: 'UcLogin',
  data() {
    return {
      token: 'uclogin'
    };
  },
  created() {
    // this.$success({
    //     title: '自动登录',
    //     content: ('系统自动登录中,请稍后...'),
    // });
    this.getJwt();
  },
  methods: {
    getJwt() {
      if (
        typeof this.$route.query.token != 'undefined' &&
        this.$route.query.token != ''
      ) {
        // const modal = this.$success({
        //     title: '自动登录',
        //     content: ('系统自动登录中,请稍后...'),
        // });
        this.$http
          .post('oauth/sso', { token: this.$route.query.token })
          .then(res => {
            console.log(res.data);
            if (res.data.state == 200) {
              this.$store.commit('setToken', res.data.data.token);
              this.$store.commit('setSiteInfo', res.data.data);
              window.localStorage.setItem('token', res.data.data.token);
              window.localStorage.setItem(
                'siteinfo',
                JSON.stringify(res.data.data)
              );
              // modal.destroy
              this.$message.success('登录成功！');
              if (typeof this.$route.query.redirect != 'undefined') {
                window.location.href = this.$route.query.redirect;
              } else {
                window.location.href = '/index';
              }
            } else {
              // this.$message.error(res.data.message, 5);
              setTimeout(() => {
                window.location.href =
                  'https://uc.cn3x.com.cn/index.php/UCDept/index';
              }, 4000);
            }
          });
      } else {
        window.location.href = 'https://uc.cn3x.com.cn/index.php/UCDept/index';
      }
    }
  }
};
</script>

<style scoped></style>
